import Clarity from "@microsoft/clarity";
import { detectWebViewModeEnv } from "@/stores/webViewMode";

const isClarityActive = () => {
  // WebView では Clarity を初期化していない（plugins/clarity.ts 参照）
  return !!import.meta.env.VITE_APP_CLARITY_PROJECT_ID && !detectWebViewModeEnv()
}

export const useClarity = () => {
  const identify = (
    userId: string, 
    customSessionId?: string | undefined, 
    customPageId?: string | undefined, 
    friendlyName?: string | undefined
  ) => {
    if (!isClarityActive()) return
    try {
      Clarity.identify(userId, customSessionId, customPageId, friendlyName);
    } catch (error) {
      console.error('Clarity identify error:', error);
    }
  };

  const event = (eventName: string) => {
    if (!isClarityActive()) return
    try {
      Clarity.event(eventName);
    } catch (error) {
      console.error('Clarity event error:', error);
    }
  };

  const setTag = (key: string, value: string | string[]) => {
    if (!isClarityActive()) return
    try {
      Clarity.setTag(key, value);
    } catch (error) {
      console.error('Clarity setTag error:', error);
    }
  };

  const consent = () => {
    if (!isClarityActive()) return
    try {
      Clarity.consent();
    } catch (error) {
      console.error('Clarity consent error:', error);
    }
  };

  const upgrade = (reason: string) => {
    if (!isClarityActive()) return
    try {
      Clarity.upgrade(reason);
    } catch (error) {
      console.error('Clarity upgrade error:', error);
    }
  }

  return {
    identify,
    event,
    setTag,
    consent,
    upgrade
  };
};